export default "__VITE_ASSET__DlQzNSIh__"